var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Multicall } from './Multicall';
function createMulticallPlugin(_a) {
    var plugin = _a.plugin, protocol = _a.protocol, type = _a.type, method = _a.method, name = _a.name, config = _a.config, addPluginOnInit = _a.addPluginOnInit, withPluginOutputs = _a.withPluginOutputs, estimateGasFromPlugins = _a.estimateGasFromPlugins, beforeSimulate = _a.beforeSimulate, flowType = _a.flowType;
    return /** @class */ (function (_super) {
        __extends(MulticallPlugin, _super);
        function MulticallPlugin(_a) {
            var chainId = _a.chainId, vaultAddress = _a.vaultAddress, walletAddress = _a.walletAddress;
            // if (type === 'LIBRARY:VIEWONLY') {
            //   config.params.push({ key: 'isOffChainOnly', multicallKey: 'isOffChainOnly', isUnique: true})
            // }
            return _super.call(this, plugin, protocol, type, method, name, config, chainId, vaultAddress, walletAddress, addPluginOnInit, withPluginOutputs, estimateGasFromPlugins, beforeSimulate, flowType) || this;
        }
        return MulticallPlugin;
    }(Multicall));
}
export default createMulticallPlugin;
